// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_el-0";
export var fileCarousel = "_el-2";
export var removeFileButton = "_el-1";